import { Box, Typography } from '@material-ui/core';
import React, { FC } from 'react';
import { useForm, useFormState } from 'react-final-form';
import { useSelector } from 'react-redux';
import { ListingFlowFormField } from './ListingFlowTypes';
import { ListingPageParamType } from '../../util/urlHelpers';
import BackToSearch from './BackToSearch';
import { EditListingPageState } from './EditListingPage.duck';
import ItemNameForm, { USER_GENERATED_TITLE } from './ItemNameForm';
import { FindItemMethod, ListingItemType } from '../../types/sharetribe/listing';
import { FIND_ITEM_METHOD } from '../../components/Shopify/Shopify.utils';

interface CannotFindItemProps {
  listingItemType?: ListingItemType;
}

const CannotFindItem: FC<CannotFindItemProps> = (props) => {
  const { listingItemType } = props;
  const form = useForm();
  const { values } = useFormState();
  const { params } = useSelector<any>((state) => state.EditListingPage) as EditListingPageState;

  const handleNameChange = (value: string) => {
    Object.keys(values)
      .filter((field) => field !== FIND_ITEM_METHOD && field !== USER_GENERATED_TITLE)
      .forEach((field) => form.change(field, undefined));
    form.change(FIND_ITEM_METHOD, FindItemMethod.CannotFind);
    form.change(USER_GENERATED_TITLE, value);
    if (listingItemType && Object.values(ListingItemType).includes(listingItemType)) {
      form.change(ListingFlowFormField.ItemType, listingItemType);
    }
  };

  const handleBackToSearchClick = () => {
    if (params?.type === ListingPageParamType.New) {
      form.reset();
    }
  };

  return (
    <>
      <Box py={1}>
        <BackToSearch onClick={handleBackToSearchClick} />
      </Box>
      <Typography variant="body1" style={{ padding: '16px 0' }}>
        You can still manually add your item. Start out by giving it a name:
      </Typography>
      <ItemNameForm onChange={handleNameChange} />
    </>
  );
};

export default CannotFindItem;
